import React from "react";


export default function UnAuthRoomCall() {
    return (
        <div style={{height:"100vh", width:"100vw", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <h1 className="mx-auto">Bạn không có quyền truy cập vào phòng này</h1>
        </div>
    );
}